import { useEffect } from 'react'
import { useRealtimeStore } from '../store/realtimeStore'
import { toast } from 'react-toastify'

export const GlobalNotificationHandler = () => {
  const lastEventType = useRealtimeStore((state) => state.lastEventType)
  const lastEventPayload = useRealtimeStore((state) => state.lastEventPayload)
  const lastEventTimestamp = useRealtimeStore((state) => state.lastEventTimestamp)

  useEffect(() => {
    if (!lastEventType || !lastEventPayload) return

    const playSound = (soundPath: string) => {
      const audio = new window.Audio(soundPath)
      audio.play().catch((e) => console.log('Audio autoplay blocked:', e))
    }

    switch (lastEventType) {
      case 'NEW_MESSAGE':
        // Check if the user is actively viewing this exact chat conversation.
        // If so, suppress the global notification to avoid duplicated spam.
        const activeContactId = (window as any).__ACTIVE_CHAT_CONTACT_ID
        if (activeContactId && String(activeContactId) === String(lastEventPayload.contact_id)) {
          return
        }

        playSound('/media/notification.ogg')
        toast.info(
          `New message from ${lastEventPayload.sender_name || 'Contact'}`,
          {
            position: 'bottom-left',
            autoClose: 5000,
            style: { borderRadius: '8px', fontWeight: 500 },
          }
        )
        break

      case 'NEW_NOTIFICATION':
        // Handle General / Signature notifications
        const notificationType = lastEventPayload.notificationType as string
        const title = lastEventPayload.title || 'New Notification'
        // const message = lastEventPayload.message || 'You have a new notification.'

        // If it's a signature event, use the achievement sound
        if (notificationType && notificationType.startsWith('SIGNATURE_')) {
          playSound('/media/achievement.ogg')
          toast.success(
            `📑 Signature Event: ${title}`,
            {
              position: 'bottom-left',
              autoClose: 6000,
              style: { borderRadius: '8px', fontWeight: 500 },
            }
          )
        } else {
          // Standard general notification or reminders
          playSound('/media/notification.ogg')
          toast.info(
            `🔔 ${title}`,
            {
              position: 'bottom-left',
              autoClose: 5000,
              style: { borderRadius: '8px', fontWeight: 500 },
            }
          )
        }
        break

      default:
        // No sound/toast for passive events like counters
        break
    }
  }, [lastEventType, lastEventPayload, lastEventTimestamp])

  // This component doesn't render any visible DOM
  return null
}
